<template>
    <div class="section">
        <div class="columns is-multiline">
            <div class="column is-full">
                <h1 class="has-text-centered title">Preguntas frecuentes.</h1>
                <b-collapse v-for="faq in faqs" :key="faq.id" class="m-b-20 " :open="false">
                    <p slot="trigger" slot-scope="props">
                        <span class="tag is-custom m-b-5 m-r-5" >
                            <b-icon :icon="!props.open ? 'plus' : 'times'" size="is-small"></b-icon>
                        </span>
                        <span class="title is-size-5">{{ faq.question }}</span>
                    </p>
                    <div class="content border-bottom m-l-20">
                        <p>{{faq.answer}}</p>
                    </div>
                    
                </b-collapse>
            </div>
        </div>
    </div>
</template>

<script>
import {getHandler} from "./../../../services/http"

export default {
    props:{
        faqsList:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            loading:false,
            faqs:[]
        }
    },
    methods:{
        async fetchFaqs(){
            this.loading = true
            this.faqs = await getHandler(this.faqsList, {error:false, success:false})
            this.loading = false
        }
    },
    created(){
        this.fetchFaqs()
    }
}
</script>

<style lang="scss" scoped>
 .is-custom{
    background-color: var(--primary);
    color: var(--text-color);
    border-radius: 50%;
}
.border-bottom{
    max-width: 700px;
}
</style>